
import React from "react";
import { Name } from "../../../lib/prm/name";
import { OptionMenu } from "../../../lib/prm/option-menu";
import { Text } from "../../../lib/prm/text";
import {sprintf} from "sprintf-js";
import {PaymentsContainer2} from "./common";
import {Action} from "../../funcs/utils";
import {FlowRender} from "../../../lib/flow-render";
import { Modal2 } from "../modal";

const WITHDRAWAL_PARAMS = {
  bank_name: new Text(new Name("bank_name", "Bank Name")),
  bank_phone: new Text(new Name("bank_phone", "Bank Telephone Number")),
  bank_city: new Text(new Name("bank_city", "Bank City")),
  bank_state: new Text(new Name("bank_state", "Bank State")),
  name_on_account: new Text(new Name("name_on_account", "Name on Bank Account")),
  aba_routing: new Text(new Name("aba_routing", "ABA/Routing #")),
  bank_account: new Text(new Name("bank_account", "Bank Account #")),
  ach_wire: new OptionMenu(
    new Name("act_wire", "Withdrawal Type"),
    [
      new Name("ach", "ACH - Electronic funds movement"),
      new Name("wire", "Wire transfers"),
    ]),
  checking_savings: new OptionMenu(
    new Name("checking_savings", "Account Type"),
    [
      new Name("checking", "Checking"),
      new Name("savings", "Savings"),
    ]),
};

const ALL_PRMS = new FlowRender(0, [
  WITHDRAWAL_PARAMS.bank_name,
  WITHDRAWAL_PARAMS.bank_city,
  WITHDRAWAL_PARAMS.bank_state,
  WITHDRAWAL_PARAMS.aba_routing,
  WITHDRAWAL_PARAMS.bank_phone,
  WITHDRAWAL_PARAMS.bank_account,
  WITHDRAWAL_PARAMS.name_on_account,
  WITHDRAWAL_PARAMS.ach_wire,
  WITHDRAWAL_PARAMS.checking_savings,
]);

const render_prm = (component, prm) => {

  if (!prm) {
    return null;
  }

  const is_option_menu = prm instanceof OptionMenu;
  const is_text = prm instanceof Text;

  return (
    <div style={{paddingRight: "1rem"}}>
      <div style={{height: "1rem"}}/>
      <div>
        { prm.name.label }
      </div>
      <div>
        { is_option_menu && prm.renderMenu(component) }
        { is_text && prm.renderInput(component, { width: "100%"}) }
      </div>
    </div>
  )
}

const render_row = (component, prm_left, prm_right) => {
  return (
    <div style={{ display: "flex"}}>
      <div style={{flex: "1"}}>
        { render_prm(component, prm_left) }
      </div>
      <div style={{flex: "1"}}>
        { render_prm(component, prm_right) }
      </div>
    </div>
  )
}
const render_withdrawal_params = (component) => {

  const is_ach = WITHDRAWAL_PARAMS.ach_wire.getValue(component.state).id === "ach";
  const ach_menu = is_ach
    ? render_prm(component, WITHDRAWAL_PARAMS.checking_savings)
    : null;

  return (
    <div>
      <div style={{height: "1rem"}}/>
      <div style={{display: "flex"}}>
        <div style={{flex: "1"}}>
          { render_prm(component, WITHDRAWAL_PARAMS.ach_wire) }
        </div>
        <div style={{flex: "1"}}>
          { ach_menu }
        </div>
      </div>
      { render_row(component, WITHDRAWAL_PARAMS.bank_name, WITHDRAWAL_PARAMS.bank_phone )}
      { render_row(component, WITHDRAWAL_PARAMS.bank_city, WITHDRAWAL_PARAMS.bank_state )}
      { render_row(component, WITHDRAWAL_PARAMS.name_on_account, null )}
      { render_row(component, WITHDRAWAL_PARAMS.aba_routing, WITHDRAWAL_PARAMS.bank_account )}
    </div>
  );
}

const SigningDialog = props => {

  const dialog_buttons = [
    { label: "Cancel", id: "cancel"},
    { label: "Sign", id: "sign"},
  ]
  const component = props.component;
  const on_click = id => {
    console.log("click", id);
  }
  const header = (
    <div align={"center"}>
      TDA Move Money Signing
    </div>
  )
  return (
    <Modal2
      header={header}
      buttonList={dialog_buttons}
      show={true}
      onClick={on_click}>
      { render_withdrawal_params(component) }
    </Modal2>
  );
}

const LaunchWithdrawalFlow = props => {

  const { component, source } = props;
  const acct_index = parseInt(component.props.acct_index, 10);
  const acct_key = sprintf("%04d", acct_index);
  const tda = component.props.tda[acct_key];
  const text = (
    <span>Before you can make a withdrawal from your {' '}
      <b>{tda.tda_account_number}</b> to your <b>{source.name}</b> {' '}
      account, you must first grant permission.
    </span>);

  let routing_text;
  if (!source.routing_number || !source.account_number) {
    routing_text = (
      <div style={{marginTop: "1rem"}}>
        <span>Before you begin, you must collect your account <b>ABA/Routing</b> and <b>Account</b> number.</span>
      </div>
    );
  }

  const dialog = component.state.show_signing_dialog
    ? (<SigningDialog component={component} source={source}/>)
    : null;

  const on_click = () => {
    component.setState({
      show_signing_dialog: true,
    })
  }
  return (
    <PaymentsContainer2
      client={component.props.client}
      title={"Grant Withdrawal Request"}>
      <div>
        { text }
      </div>
      <div style={{height: "1rem"}}/>
      <div>
        <span>You can do this by electronically signing a <b>TDA Move Money</b> form.</span>
      </div>
      <div>{ routing_text }</div>
      <div style={{marginTop: "1rem", display: "flex", justifyContent: "center"}}>
        <Action onClick={on_click}>
          Begin Signing
        </Action>
      </div>
      { dialog }
    </PaymentsContainer2>
  );
}

const withdrawal_request_state = component => {
  const state = {};
  ALL_PRMS.init(state, {}, component);
  state.show_signing_dialog = false;
  return state;
}

export { WITHDRAWAL_PARAMS, render_withdrawal_params, LaunchWithdrawalFlow, withdrawal_request_state };
